<template>
  <div @click="showDropDown = false" class="down_question">    
  <div class="qes_txt" :style="{'color':surveyTheme.bodyColor}">
    <i class="qes_num" v-if="surveyTheme.openCode">{{data.showNum}}.</i>
    <div class="qes_name" v-html="data.qesName"></div>
  </div>
    <div class="answers">
      <div class="drop_down_box">
        <div class="select_unanswer" @click.stop="openDropDown">
          <span :style="fontSize == 1 ? {'color':color,'fontSize':'14px'} : {'color':color,'fontSize':'16px'}" class="placeholder">{{showText}}</span>
          <img src="@/assets/images/survey/icon_dropdown.png" alt="" class="icon_dropdown">
        </div>
        <div v-if="showDropDown" class="select_options">
          <div @click.stop="selectAnswer(a)" v-for="(a,idx) in data.answers" :key="idx" :style="{'color':color}" class="option">{{a.ansName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

 export default {
   components: { 
    
  },
  props: ['data','currentPage','index','color','fontSize'],
  watch: {  
    // 'data'(){
    //   console.log('下拉题data值变了',this.data);
    //   if(this.data.showSelected){
    //     this.showSelected = this.data.showSelected;
    //     console.log('下拉有值',this.showSelected);
    //   }else{
    //     console.log('没有值');
    //   }
    // }
  },
  data(){
    return {
      surveyTheme:{},                         //问卷主题
      showSelected:"",                        //已选答案ID       (提交后台用)
      showText:"请选择",                      //已选答案文本     (前端回显用)
      selectData:{},                          //已选答案相关对象 (提交后台用)
      showDropDown:false,                     //是否显示下拉菜单
    }
  },
  created(){
    this.data.qesName = this.data.qesName.replaceAll('\n','<br/>');
    this.showSelected = this.data.showSelected ? this.data.showSelected : '';
    if(this.data.showSelected){
      this.data.answers.forEach(item=>{
        if(item.ansId == this.showSelected){
          this.showText = item.ansName;
          return;
        }
      });
    }
    this.surveyTheme = JSON.parse(sessionStorage.getItem("surveyTheme"));
    // console.log(this.surveyTheme);
    // console.log('下拉题data',this.data);
  },
  methods:{
    // 显示下拉菜单
    openDropDown(){
      this.showDropDown = !this.showDropDown;
    },
    // 选择答案
    selectAnswer(item){
      this.showText = item.ansName;
      this.showSelected = item.ansId;
      this.showDropDown = false;
      // console.log(item,this.showSelected);
      this.data.showSelected = this.showSelected;
      let obj = {};
      obj.ansId = item.ansId;
      obj.ansName = item.ansName;
      obj.ansOrder = item.ansOrder;
      obj.qesId = item.qesId;
      obj.surveyId = this.data.surveyId;
      obj.qesType = this.data.qesType;
      obj.otherType = this.data.otherType;
      obj.groId = this.data.groId;
      obj.qesName = this.data.qesName;
      obj.qesNum = this.data.qesNum;
      obj.qesOrder = this.data.qesOrder;
      this.selectData.gIndex = this.currentPage - 1;
      this.selectData.qIndex = this.index;
      this.selectData.submitQesObj = obj;
      // console.log(this.selectData);
      this.$emit("sendAnswer",this.selectData);
    }
  }
}
</script>
<style lang="less" scoped>
  .down_question{
    background-color: transparent;
    width: 100%;
    padding: 60px 40px;
    box-sizing: border-box;
    .qes_txt{
      margin-bottom: 40px;
      font-size: 36px;
      color: #333;
      line-height: 56px;
      display: flex;
      .qes_num{
        font-size: 34px;
        // line-height: 65px;
        margin-right: 10px;
      }
      .qes_name{
        font-size: 36px;
        display: inline;
        word-break: break-all;
      }
    }
    .answers{
      width: 100%;
      .drop_down_box{
        width: 480px;
        position: relative;
        .select_unanswer{
          padding: 20px 24px;
          box-sizing: border-box;
          font-size: 28px;
          border: 1px solid #f3eded;
          border-radius: 12px;
          background-color: #fbfbfb;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .placeholder{
            color: #999;
          }
        }
        .select_options{
          position: absolute;
          top: 74px;
          left: 0;
          width: 480px;
          background: #fff;
          box-shadow: 0 2px 24px 0 rgb(0 0 0 / 8%);
          border-radius: 4px;
          z-index:99;
          .option{
            padding: 30px 20px;
            font-size: 28px;
            color: #333333;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/selectQuestion/downQuestion.vue